import ApiClient from './ApiClient';

class ProcedureScoresAPI extends ApiClient {
  constructor() {
    super('procedure_scores', { accountScoped: true, apiVersion: 'v2' });
  }
}

export default new ProcedureScoresAPI();
